module.exports = __webpack_public_path__ + "img/img-17.2e22e8af.png";